module.exports = __webpack_public_path__ + "e592108a6fb225db2713f303f6b4f903.svg";